import React from 'react'
import { Form, Select, Spin } from 'antd'
import { ApiRequest } from '../../../services/api/api'
import { getRandomKey } from '../../../services/lib/utils/helpers'
import debounce from 'lodash/debounce'

interface CommonEditGoogleMapAddressSelectComponentPropsInterface {
	urlInfoKey: string
	label?: string
	required?: boolean
	disabled?: boolean
	width?: string
	propsFn: any
}

const DebounceSelect = ({ fetchOptions, debounceTimeout = 800, ...props }: any) => {
  const [fetching, setFetching] = React.useState(false)
  const [options, setOptions] = React.useState<any>([])
  const fetchRef = React.useRef(0)
  const debounceFetcher = React.useMemo(() => {
    const loadOptions = (value: any) => {
      fetchRef.current += 1
      const fetchId = fetchRef.current
      setOptions([])
      setFetching(true)
      fetchOptions(value).then((newOptions: any) => {
        if (fetchId !== fetchRef.current) {
          return
        }
        setOptions(newOptions)
        setFetching(false)
      })
    }

    return debounce(loadOptions, debounceTimeout)
  }, [fetchOptions, debounceTimeout])
  return (
    <Select
      filterOption={false}
      onSearch={debounceFetcher}
      notFoundContent={fetching ? <Spin size="small" /> : null}
      {...props}
      options={options}
    />
  )
} // Usage of DebounceSelect

const fetchUserList = async (username: any) => {
  console.log('fetching address', username)
  const result: any = [{
    label: username,
    value: username,
  }]

  if (!username || username.length < 2) {
    return result
  }

  // 检查query是否包含至少3个部分（按空格、+号或其他分隔符分割）
  const queryParts = username.split(/[\s+]+/).filter((part: string) => part.trim().length > 0)
  // console.log('Query parts:', queryParts.length, queryParts)

  // if (queryParts.length < 3) {
  //   console.log('Query has less than 3 parts, skipping API call')
  //   return result
  // }

  // 注释掉地址 autocomplete API 调用
  // try {
  //   const apiResult = await ApiRequest({
  //     url: 'AddressSearch/Search',
  //     method: 'get',
  //     params: {
  //       Query: username,
  //       Limit: 5,
  //       CountryCode: 'nz'
  //     }
  //   })

  //   console.log('API Result:', apiResult)
  //   console.log('API Result data:', apiResult?.data)
  //   console.log('API Result features:', apiResult?.data?.data?.features)

  //   if (apiResult?.data?.data?.features?.length) {
  //     const addressOptions = apiResult.data.data.features.map((feature: any) => {
  //       const props = feature.properties
  //       console.log('Feature properties:', props)

  //       // 构建地址字符串：门牌号 街道, 地区, 城市, 邮编
  //       const houseStreet = [props.housenumber, props.street].filter((part: string) => part).join(' ')
  //       const locationParts = [props.district, props.city].filter((part: string) => part)

  //       const fullAddressParts = [houseStreet, ...locationParts, props.postcode].filter((part: string) => part)
  //       const fullAddress = fullAddressParts.join(', ')
  //       console.log('Generated address:', fullAddress)

  //       return {
  //         label: fullAddress,
  //         value: fullAddress,
  //         // 保存完整的地址信息，供后续使用
  //         rawData: props
  //       }
  //     })

  //     console.log('Address options:', addressOptions)
  //     result.push(...addressOptions)
  //   } else {
  //     console.log('No features found in API response')
  //   }
  // } catch (error) {
  //   console.error('Failed to fetch addresses:', error)
  // }

  console.log('Final result:', result)
  return result
}
const fetchUserListBack = async (username: any) => {
  console.log('fetching user', username)
  const result: any = [{
    label: username,
    value: username,
  }]
  const apiResult = await ApiRequest({
    url: 'Common/GetGoogleAddr?Path=' + username,
    method: 'get'
  })
  if (apiResult.data.predictions?.length) {
    result.push(...apiResult.data.predictions.map((row: any, i: any) => ({
      label: row.description,
      value: row.description,
    })))
  }
  return result
}

const CommonEditGoogleMapAddressSelectComponent = (props: CommonEditGoogleMapAddressSelectComponentPropsInterface) => {
  const [value, setValue] = React.useState()
  return (
	  <Form.Item
		  key={props.urlInfoKey + getRandomKey()}
		  label={props.label}
		  name={props.urlInfoKey}
		  initialValue={props.propsFn.rowData[props.urlInfoKey]}
		  rules={[{ required: props.required, message: props.label + ' is required!' }]}
	  >
      <DebounceSelect
        mode="single"
        showSearch
        value={value}
        placeholder="Search address"
        fetchOptions={fetchUserList}
        onChange={(newValue: any) => {
          setValue(newValue)
	        props.propsFn.onRowDataChange({
		        ...props.propsFn.rowData,
		        [props.urlInfoKey]: newValue
	        })
        }}
        style={{
          width: '100%',
        }}
        initialValue={props.propsFn.rowData[props.urlInfoKey]}
      />
	  </Form.Item>
  )
}

export default CommonEditGoogleMapAddressSelectComponent
